export class TextVideo {
  constructor() {
    this._videos = document.querySelectorAll('[data-autoplay-scroll]')

    if (!this._videos.length) return;

    this.init()
  }

  init() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target

        if (entry.isIntersecting) {
          // ponytail: muted requis pour l'autoplay sans interaction (politique navigateurs)
          video.muted = true
          video.play().catch(() => {})
        } else {
          video.pause()
        }
      })
    }, { threshold: 0.35 })

    this._videos.forEach((video) => observer.observe(video))
  }
}
